import React from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { LoginUser } from "../../../../Controllers/Login/LoginController";

import { Organizacao } from "../../../../Interfaces/Login/OrganizacaoInterface";
import {
    LoginOrganizacao,
    Login,
} from "../../../../Interfaces/Login/LoginInterface";

import "./styles/modalOrganizacoesStyles.css";
import { GetOrganizacaoController } from "../../../../Controllers/Organizacao/Organizacao";
import { GetUserInfor } from "../../../../Controllers/Users/UsersController";
import { useUserInfor } from "../../../../Context/User";
import { FazerLoginADController } from "../../../../Controllers/Login/LoginAD/LoginADControllers";

interface ModalLanceInterface {
    usuario?: LoginOrganizacao;
    lstOrganizacoes?: Array<Organizacao>;
    StateModalShow: React.Dispatch<React.SetStateAction<boolean>>;
    show: boolean;
    tokenMSAL?: string;
}

export default function ModalLance(props: ModalLanceInterface) {
    const history = useHistory();

    const { setUserInfor, setOrgInfor, updateConfig } = useUserInfor();

    const handleClose = () => {
        props.StateModalShow(false);
    };

    if (!props.lstOrganizacoes) return null;
    if (!props.usuario) return null;

    const encodedData = localStorage.getItem("userData");
    const loginEncodedData = encodedData
        ? JSON.parse(atob(encodedData ?? ""))
        : null;

    function selectOrg(idOrg: string) {
        const user: Login = {
            Email: props.usuario!.Email,
            Password: props.usuario!.Password,
            IDOrganizacao: idOrg,
        };
        const LoginPromise = props.tokenMSAL
            ? FazerLoginADController(props.tokenMSAL, idOrg)
            : LoginUser(user);
        LoginPromise.then((token) => {
            history.push("/Geral");

            GetOrganizacaoController().then((res) => {
                setOrgInfor(res);
                GetUserInfor().then((response) => {
                    setUserInfor({ ...response, token });
                    if (loginEncodedData.FL_ULTIMO_MODULO) {
                        if (
                            String(loginEncodedData?.ID_ORGANIZACAO) ===
                                String(res.ID_ORGANIZACAO) &&
                            Number(loginEncodedData?.ID_USUARIO) ===
                                Number(response.ID_USUARIO) &&
                            String(loginEncodedData?.ultimaUrl).length > 0
                        ) {
                            history.push(`/${loginEncodedData.ultimaUrl}`);
                        } else {
                            history.push("/Geral");
                        }
                    } else {
                        history.push("/Geral");
                    }
                });
            });

            updateConfig();
        });
    }

    return (
        <Modal
            show={props.show}
            onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body
                className={`orgBody ${
                    props.lstOrganizacoes.length > 2 && "moreThanTwo"
                } `}
            >
                {props.lstOrganizacoes.map((response) => {
                    return (
                        <div
                            className="orgCard"
                            key={response.ID_ORGANIZACAO}
                            onClick={() => {
                                selectOrg(response.ID_ORGANIZACAO);
                            }}
                        >
                            <div className="orgImg">
                                <img
                                    src={`https://crm.capys.com.br${response.URL_LOGO.replace(
                                        "~",
                                        ""
                                    )}`}
                                    alt="logo Organizacao"
                                />
                            </div>
                            <h4 className="orgName">
                                {response.DS_ORGANIZACAO}
                            </h4>

                            <div className="orgModules">
                                <strong>Módulos disponíveis:</strong>

                                {response.MODULOS.map((modulo) => {
                                    return (
                                        <li key={modulo.ID_MODULO}>
                                            {modulo.DS_MODULO}
                                        </li>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </Modal.Body>
        </Modal>
    );
}
